const SELECTOR =
  'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';

export function findFirstFocusableNode(
  element: HTMLElement
): HTMLElement | null {
  if (element.matches(SELECTOR)) {
    return element;
  }

  return element.querySelector(SELECTOR);
}



// WEBPACK FOOTER //
// ../src/focus/findFirstFocusableNode.ts